/* OO(2026-10-12) 絞り込みの「カラー」が記号で出ているのを、色の名前に直します

   ★何が起きていたか
     一覧ページの絞り込みを開くと、カラーのところが
       gid://shopify/TaxonomyValue/14
     のような内部の記号で14色ぜんぶ出ていました。お客さんには何色か分かりません。

   ★なぜ起きるか
     Shopify 側には色の名前（ブラック・ホワイト…）がちゃんと入っていますが、
     絞り込みが「ベースcolor」という内部の値でまとめていて、
     テーマがその名前を出せていません。

   ★ここでやること
     画面に出ている記号を、色の名前に置き換えるだけです。
     Shopify のデータは一切さわりません。絞り込みの動き（押したら絞れる）も変わりません。
     色の四角は**テーマがもともと出しています**（二重にならないよう、こちらでは足しません）。

   ★根本から直すなら
     Shopify の「Search & Discovery」アプリで、カラーの絞り込みを
     商品の色の項目に切り替えます（管理画面の操作が必要）。
     それができるまでの間の直しです。
*/
(function () {
  'use strict';

  /* 番号と色の対応。2026-10-12 に Shopify の色データ（shopify--color-pattern）から
     実際に読み取ったものです。番号10だけは店に無かったので Shopify の標準に合わせています。 */
  var NAMES = {
    '1': 'ブラック',
    '2': 'ブルー',
    '3': 'ホワイト',
    '4': 'ゴールド',
    '5': 'シルバー',
    '6': 'ベージュ',
    '7': 'ブラウン',
    '8': 'グレー',
    '9': 'グリーン',
    '10': 'オレンジ',
    '11': 'ピンク',
    '12': 'パープル',
    '13': 'レッド',
    '14': 'イエロー',
    '15': 'ネイビーブルー'
  };

  var RE = /gid:\/\/shopify\/TaxonomyValue\/(\d+)/g;

  /* 文字だけを置き換えます（ボタンや色の四角の作りには手を触れません） */
  function fixText(root) {
    var walker = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, null, false);
    var list = [];
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue && node.nodeValue.indexOf('gid://shopify/TaxonomyValue/') >= 0) list.push(node);
    }
    list.forEach(function (t) {
      var next = t.nodeValue.replace(RE, function (whole, n) {
        return NAMES[n] ? NAMES[n] : whole;
      });
      if (next !== t.nodeValue) t.nodeValue = next;
    });
  }

  function run() { try { fixText(document.body); } catch (e) {} }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  /* 絞り込みの引き出しはあとから開きます。開いたときにも直すために見張ります。 */
  var timer = setInterval(run, 600);
  setTimeout(function () { clearInterval(timer); }, 30000);

  if (window.MutationObserver) {
    var mo = new MutationObserver(function (recs) {
      for (var i = 0; i < recs.length; i += 1) {
        if (recs[i].addedNodes && recs[i].addedNodes.length) { run(); return; }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  /* 絞り込みを押し直したときのために、クリックのあとも1回 */
  document.addEventListener('click', function () { setTimeout(run, 400); }, true);
})();
